export { default as ModalHorario } from "./ModalHorario";
export { default as ModalNuevaConfiguracion } from "./ModalNuevaConfiguracion";
export {
  default as ModalEditarMantenimientos
} from "./ModalEditarMantenimientos";
export { default as ModalEditarClubes } from "./ModalEditarClubes";
export { default as ModalConfirmarEliminar } from "./ModalConfirmarEliminar";
